export default __webpack_public_path__ + "static/media/make_a_report.807ee1b8.svg";